"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var Gavel = function Gavel(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    fill: "currentColor",
    d: "M4.912 19.086a1.408 1.408 0 002.044-.056l5.195-5.728a.627.627 0 00-.024-.863l-.56-.56a.631.631 0 00-.866-.023l-5.732 5.19a1.404 1.404 0 00-.057 2.04zM9.944 8.692l3.757-3.758a.626.626 0 10-.885-.885L9.058 7.806a.626.626 0 00.886.886zm.904.164c-.356.355.317 1.606 1.504 2.792 1.186 1.187 2.437 1.86 2.792 1.504l3.008-3.008c.356-.355-.317-1.606-1.504-2.792-1.186-1.187-2.437-1.86-2.792-1.504l-3.008 3.008zm4.46 6.086a.626.626 0 00.886 0l3.757-3.758a.626.626 0 10-.885-.885l-3.758 3.757a.626.626 0 000 .886z"
  }));
};

var _default = (0, _react.forwardRef)(Gavel);

var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Gavel, "Gavel", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Gavel.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Gavel.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9JY29ucy9HYXZlbC50c3giXSwibmFtZXMiOlsiR2F2ZWwiLCJwcm9wcyIsInJlZiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7OztBQUFBOzs7Ozs7Ozs7Ozs7O0FBRUEsSUFBTUEsS0FBcUUsR0FBRyxTQUF4RUEsS0FBd0UsQ0FBQ0MsS0FBRCxFQUFRQyxHQUFSO0FBQUEsU0FDNUU7QUFBSyxJQUFBLEtBQUssRUFBRSxFQUFaO0FBQWdCLElBQUEsTUFBTSxFQUFFLEVBQXhCO0FBQTRCLElBQUEsT0FBTyxFQUFDO0FBQXBDLEtBQW9ERCxLQUFwRDtBQUEyRCxJQUFBLEdBQUcsRUFBRUM7QUFBaEUsTUFDRTtBQUNFLElBQUEsSUFBSSxFQUFDLGNBRFA7QUFFRSxJQUFBLENBQUMsRUFBQztBQUZKLElBREYsQ0FENEU7QUFBQSxDQUE5RTs7ZUFTZSx1QkFBV0YsS0FBWCxDOzs7Ozs7Ozs7Ozs7OzBCQVRUQSxLIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IGZvcndhcmRSZWYsIFJlZkZvcndhcmRpbmdDb21wb25lbnQsIFNWR1Byb3BzIH0gZnJvbSAncmVhY3QnO1xuXG5jb25zdCBHYXZlbDogUmVmRm9yd2FyZGluZ0NvbXBvbmVudDxTVkdTVkdFbGVtZW50LCBTVkdQcm9wczxTVkdTVkdFbGVtZW50Pj4gPSAocHJvcHMsIHJlZikgPT4gKFxuICA8c3ZnIHdpZHRoPXsyNH0gaGVpZ2h0PXsyNH0gdmlld0JveD1cIjAgMCAyNCAyNFwiIHsuLi5wcm9wc30gcmVmPXtyZWZ9PlxuICAgIDxwYXRoXG4gICAgICBmaWxsPVwiY3VycmVudENvbG9yXCJcbiAgICAgIGQ9XCJNNC45MTIgMTkuMDg2YTEuNDA4IDEuNDA4IDAgMDAyLjA0NC0uMDU2bDUuMTk1LTUuNzI4YS42MjcuNjI3IDAgMDAtLjAyNC0uODYzbC0uNTYtLjU2YS42MzEuNjMxIDAgMDAtLjg2Ni0uMDIzbC01LjczMiA1LjE5YTEuNDA0IDEuNDA0IDAgMDAtLjA1NyAyLjA0ek05Ljk0NCA4LjY5MmwzLjc1Ny0zLjc1OGEuNjI2LjYyNiAwIDEwLS44ODUtLjg4NUw5LjA1OCA3LjgwNmEuNjI2LjYyNiAwIDAwLjg4Ni44ODZ6bS45MDQuMTY0Yy0uMzU2LjM1NS4zMTcgMS42MDYgMS41MDQgMi43OTIgMS4xODYgMS4xODcgMi40MzcgMS44NiAyLjc5MiAxLjUwNGwzLjAwOC0zLjAwOGMuMzU2LS4zNTUtLjMxNy0xLjYwNi0xLjUwNC0yLjc5Mi0xLjE4Ni0xLjE4Ny0yLjQzNy0xLjg2LTIuNzkyLTEuNTA0bC0zLjAwOCAzLjAwOHptNC40NiA2LjA4NmEuNjI2LjYyNiAwIDAwLjg4NiAwbDMuNzU3LTMuNzU4YS42MjYuNjI2IDAgMTAtLjg4NS0uODg1bC0zLjc1OCAzLjc1N2EuNjI2LjYyNiAwIDAwMCAuODg2elwiXG4gICAgLz5cbiAgPC9zdmc+XG4pO1xuXG5leHBvcnQgZGVmYXVsdCBmb3J3YXJkUmVmKEdhdmVsKTtcbiJdfQ==